export default {
    pages: {
        '220 - Variable': [
            {
                id: '213866', // button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: '2'
                    }
                ]
            },
            {
                id: '213857', // answer_node.
                attributes: [
                    {
                        name: 'height',
                        value: '160'
                    }
                ]

            }
        ],
        '221 - Conclusion': [
            {
                id: '211938', // button_node.
                attributes: [
                    {
                        name: 'zIndex',
                        value: '2'
                    }
                ]
            },
            {
                id: '211929', // answer_node.
                attributes: [
                    {
                        name: 'height',
                        value: '70'
                    }
                ]
            },
        ]
    }
};



// WEBPACK FOOTER //
// ./src/js/transformers/MO.SMACH.3.0.0.js